var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClipboardChecklist = function SvgClipboardChecklist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.167 4.75H8.833c-.751 0-1.36.61-1.36 1.361V27.89c0 .752.609 1.361 1.36 1.361h16.334c.751 0 1.36-.61 1.36-1.361V6.11c0-.752-.609-1.361-1.36-1.361Z",
    stroke: "#5D5BEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.167a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM14.666 18.186a4.222 4.222 0 0 0-1.697 1.638 4.758 4.758 0 0 0-.636 2.373c0 .169.062.33.17.45a.56.56 0 0 0 .413.186h8.167a.56.56 0 0 0 .413-.186c.109-.12.17-.281.17-.45a4.76 4.76 0 0 0-.631-2.384 4.224 4.224 0 0 0-1.702-1.646",
    stroke: "#F26722",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgClipboardChecklist;